import { NavigationGuardNext, Route } from 'vue-router';

import { LIST_PERMISSION } from '@/constant/ListPermission';
import { LIST_PLAN_ID } from '@/constant/PlansIDs';
import store from '@/store';
import Permission from './index';

export function permissionRanking(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  const verifyPermission = PermissionClass.can(LIST_PERMISSION.RANKING);
  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  if (verifyPermission || isPlanFree) {
    next();
    return;
  }

  next({ name: 'Dashboard' }); 

}
